var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepNumberThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 122,
    viewBox: "0 0 95 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.39 121.04C37.1167 121.04 28.9 119.963 20.74 117.81C12.58 115.543 5.66667 112.37 0 108.29L10.71 87.21C15.2433 90.4967 20.5133 93.1033 26.52 95.03C32.5267 96.9567 38.59 97.92 44.71 97.92C51.6233 97.92 57.0633 96.56 61.03 93.84C64.9967 91.12 66.98 87.38 66.98 82.62C66.98 78.0867 65.2233 74.5167 61.71 71.91C58.1967 69.3033 52.53 68 44.71 68H32.13V49.81L65.28 12.24L68.34 22.1H5.95V0H89.25V17.85L56.27 55.42L42.33 47.43H50.32C64.94 47.43 75.99 50.7167 83.47 57.29C90.95 63.8633 94.69 72.3067 94.69 82.62C94.69 89.3067 92.9333 95.5967 89.42 101.49C85.9067 107.27 80.5233 111.973 73.27 115.6C66.0167 119.227 56.7233 121.04 45.39 121.04Z",
    fill: "url(#paint0_linear_61_1849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1849",
    x1: 50.4727,
    y1: 21,
    x2: 50.4727,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepNumberThree);
export default __webpack_public_path__ + "static/media/Step_number_three.8da28f21433755e3220b0f46c485e657.svg";
export { ForwardRef as ReactComponent };